import { Suspense, useEffect } from 'react';
import { BrowserRouter } from '@leagueplatform/routing';

import { ReactQueryDevtools } from 'react-query/devtools';

import { FullPageError } from '@leagueplatform/web-common-components';
import { config } from 'init-config';
import { ErrorBoundaryWrapper } from 'components/error/error-boundary.component';
import { APP_MANAGED_ROUTES } from 'common/constants';
import { QueryClientProvider } from 'react-query';
import League from '@leagueplatform/core';
import { useApp } from 'hooks/use-app.hook';
import { FullPageLoadingSpinner } from 'components/loaders/full-page-loading-spinner.component';
import AppRoutes from './components/AppRoutes';

export function App() {
  const { isOnline, isOffline, queryClient, initializeApp } = useApp();

  useEffect(() => {
    initializeApp();
  }, [initializeApp]);

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <League.LeagueProvider config={config} treatConfigAsInitialOnly>
          <ErrorBoundaryWrapper>
            <Suspense fallback={FullPageLoadingSpinner}>
              {isOffline && (
                <FullPageError
                  route={APP_MANAGED_ROUTES.HOME}
                  error={undefined}
                />
              )}
              {isOnline && (
                <ErrorBoundaryWrapper>
                  <AppRoutes />
                </ErrorBoundaryWrapper>
              )}
              <ReactQueryDevtools />
            </Suspense>
          </ErrorBoundaryWrapper>
        </League.LeagueProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
